import React from "react";

function IconCustomPage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.25a.75.75 0 01.75-.75h11a.75.75 0 01.53.22l3 3c.141.14.22.331.22.53v13a.75.75 0 01-.75.75h-14a.75.75 0 01-.75-.75v-16zM4 3v14.5h12.5V5.56L13.94 3H4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 11.5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM5.25 14.5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM5.5 5.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75v-3zM7 6v1.5h1.5V6H7z"
      />
    </svg>
  );
}

export default IconCustomPage;
